<template>
<div class="gate-2d-page">
    <div class="main">
        <Gate2dData ref="gateData" v-bind:gateName="this.$router.currentRoute.name" v-bind:trackCount="audioTracksCount" />
        <AudioPlaylistPlayer />
    </div>
</div>
</template>

<script>
import Gate2dData from "@/components/Gate2dData";
import AudioPlaylistPlayer from "@/components/AudioPlaylistPlayer";
export default {
    name: "Orange",
    components: {
        Gate2dData,
        AudioPlaylistPlayer
    },
    data() {
        return {
            audioTracksCount: 20,
        }
    },
}
</script>

<style scoped>

</style>
